export enum LocalStorageNames {
  HISTORY = 'history',
  FAVORITE = 'favorite'
}
